import { createContext } from 'react';
import { emptyFunc } from '@shared/react';
import { IReserveComputationDate } from './';

type DateRange = [string | null, string | null];

export interface IReserveComputationTableContext {
    dateRange: DateRange;
    dates: IReserveComputationDate[];
    setDateRange: (range: DateRange) => void;
    onReserveComputationClick: (date: IReserveComputationDate) => void;
}

export const ReserveComputationTableContext = createContext<IReserveComputationTableContext>({
    dateRange: [null, null],
    dates: [],
    setDateRange: emptyFunc,
    onReserveComputationClick: emptyFunc,
});
